module.exports = __webpack_public_path__ + "img/nearAmount.3db78dd5.svg";